'use client';

import { useLocale } from 'next-intl';
import type { ComponentProps } from 'react';
import { Link, usePathname } from '@/lib/routing';
import { getZoneFromHref, getZoneFromPath } from '@/lib/utils/zones';

interface SidebarLinkProps extends Omit<ComponentProps<'a'>, 'href'> {
  /** Locale-less path, e.g. `/trade/usdt/BTCUSDT` or `/rewards/leaderboard`. */
  href: string;
}

/**
 * A soft `<Link>` only resolves inside the zone it was rendered in, so a target
 * in another zone (the trade terminal, sign-up) is a plain `<a>` with the
 * locale written out.
 */
export function SidebarLink({ href, children, ...props }: SidebarLinkProps) {
  const locale = useLocale();
  const sameZone = getZoneFromHref(href) === getZoneFromPath(usePathname());

  if (sameZone) {
    return (
      <Link href={href} {...props}>
        {children}
      </Link>
    );
  }
  return (
    <a href={`/${locale}${href}`} {...props}>
      {children}
    </a>
  );
}
